// Send Unmasking Invitation Bulk
export const SEND_UNMASKING_INVITATION_BULK_REQUEST = 'SEND_UNMASKING_INVITATION_BULK_REQUEST';
export const SEND_UNMASKING_INVITATION_BULK_DONE = 'SEND_UNMASKING_INVITATION_BULK_DONE';
export const SEND_UNMASKING_INVITATION_BULK_FAILED = 'SEND_UNMASKING_INVITATION_BULK_FAILED';
export const SEND_UNMASKING_INVITATION_BULK_RESET = 'SEND_UNMASKING_INVITATION_BULK_RESET';